export type OfficialRateView = {
    id: number;
    accomodationUnitTypeId: number;
    serviceTypeId: number | null;
    currencyId: number;
    seasonName: string;
    dateFrom: string;
    dateTo: string;
    price: number;
    inputPrice: number | null;
    minimumStay: number;
    isMain: boolean;
  
    noDeparturesMonday: boolean;
    noDeparturesTuesday: boolean;
    noDeparturesWednesday: boolean;
    noDeparturesThursday: boolean;
    noDeparturesFriday: boolean;
    noDeparturesSaturday: boolean;
    noDeparturesSunday: boolean;
  
    noArrivalsMonday: boolean;
    noArrivalsTuesday: boolean;
    noArrivalsWednesday: boolean;
    noArrivalsThursday: boolean;
    noArrivalsFriday: boolean;
    noArrivalsSaturday: boolean;
    noArrivalsSunday: boolean;
};

export class OfficialRateModel {
    id = 0;
    accomodationUnitTypeId = 0;
    serviceTypeId = null as number | null;
    ratePlanId = null as number | null;
    currencyId = 0;
    seasonName = "";
    dateFrom = "";
    dateTo = "";
    price = 0 as number | null;
    inputPrice = null as number | null;
    minimumStay = 1;
    maximumStay = undefined as number | undefined;
    minBookableBeforeCheckin = undefined as number | undefined;
    maxBookableBeforeCheckin = undefined as number | undefined;
    isMain = false;

    noDeparturesMonday = false;
    noDeparturesTuesday = false;
    noDeparturesWednesday = false;
    noDeparturesThursday = false;
    noDeparturesFriday = false;
    noDeparturesSaturday = false;
    noDeparturesSunday = false;

    noArrivalsMonday = false;
    noArrivalsTuesday = false;
    noArrivalsWednesday = false;
    noArrivalsThursday = false;
    noArrivalsFriday = false;
    noArrivalsSaturday = false;
    noArrivalsSunday = false;
    noSales = false;

    officialRateRules = [] as OfficialRateRuleModel[];
    ratePlanIdsToUpdate = [] as number[];
    derivedRatePlanIdsToUpdateRestrictions = [] as number[];
    occupancyBasedRules = [] as OfficialRateOccupancyBasedRule[];
}

export interface OfficialRateOccupancyBasedRule {
  id: number;
  price: number | null;
  inputPrice: number | null;
  minStay: number | null;
  maxStay: number | null;
  minPersons: number | null;
  maxPersons: number | null;
  isDefaultLOSCategory: boolean;
  isDefaultPAXCategory: boolean;
  uniqueKey: string;
}

export interface OfficialRateRuleModel {
    minPersons: number | null;
    maxPersons: number | null;
    minStay: number | null;
    maxStay: number | null;
    isDefaultLOSCategory: boolean;
    isDefaultPAXCategory: boolean;
    price: number | null;
    inputPrice: number | null;
    uniqueKey: string;
    noSales: boolean;
    obInputPriceDifference: number | null;
    obInputPriceDifferenceIsAbsolute: boolean | null;
    obOutputPriceDifference: number | null;
    obOutputPriceDifferenceIsAbsolute: boolean | null;
    losInputPriceDifference: number | null;
    losInputPriceDifferenceIsAbsolute: boolean | null;
    losOutputPriceDifference: number | null;
    losOutputPriceDifferenceIsAbsolute: boolean | null;

    accomodationUnitTypesLOSCategoryId: number | null;
    accomodationUnitTypesPAXCategoryId: number | null;
}

export interface LOSCategoryViewModel {
    id: number;
    minStay: number;
    maxStay: number;
    isDefault: boolean;
    losInputPriceDifference: number | null;
    losInputPriceDifferenceIsAbsolute: boolean | null;
    losOutputPriceDifference: number | null;
    losOutputPriceDifferenceIsAbsolute: boolean | null;
}

export interface PAXCategoryViewModel {
    id: number;
    minPersons: number;
    maxPersons: number;
    isDefault: boolean;
    obInputPriceDifference: number | null;
    obInputPriceDifferenceIsAbsolute: boolean | null;
    obOutputPriceDifference: number | null;
    obOutputPriceDifferenceIsAbsolute: boolean | null;
}

export interface OfficialRateRulesCategoriesViewModel {
    losCategories: LOSCategoryViewModel[];
    paxCategories: PAXCategoryViewModel[];
}

export enum OfficialRateRulesGroupingEnum {
    ByOccupancy = 1,
    ByLengthOfStay = 2,
}